import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreatePlaylistDocument } from './create.generated';

export const useCreatePlaylist = (options: ApiOptions<typeof CreatePlaylistDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreatePlaylistDocument, {
    ...useNotifications(CreatePlaylistDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.playlists.create_success'),
    }),
    ...options,
  });
};
